import React from 'react'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'
import AssignmentIcon from '@mui/icons-material/Assignment'
import ContactsIcon from '@mui/icons-material/Contacts'
import LuggageIcon from '@mui/icons-material/Luggage'
import PercentIcon from '@mui/icons-material/Percent'

export const OTP_MODAL_BENEFITS = [
    { textKey: 'specialOffers', icon: <PercentIcon sx={{ fontSize: 18 }} /> },
    { textKey: 'addTravellerInfo', icon: <ContactsIcon sx={{ fontSize: 18 }} /> },
    { textKey: 'quickCheckout', icon: <LuggageIcon sx={{ fontSize: 18 }} /> },
    { textKey: 'manageBooking', icon: <AssignmentIcon sx={{ fontSize: 18 }} /> },
    { textKey: 'immediateRefund', icon: <AccountBalanceWalletIcon sx={{ fontSize: 18 }} /> }
]
